/* eslint-disable import/prefer-default-export */
import { Amplify } from 'aws-amplify';
import {
  fetchAuthSession,
  getCurrentUser,
  signOut,
} from 'aws-amplify/auth';

import store from '../store';
import { setAccessToken, clearAccessToken } from '../store/common/accessToken';

import { getEnvVariable } from './getEnv';
import { removeDailyStorage } from './storage';

const getCongnitoConfig = () => {
  const domain = getEnvVariable('DOMAIN') === 'ohg-sfa-stg2'
    ? 'ohg-sfa-stg'
    : getEnvVariable('DOMAIN');
  const userPoolWebClientId = getEnvVariable('USER_POOL_CLIENT_ID');
  const userPoolId = getEnvVariable('USER_POOL_ID');
  const redirectURL = getEnvVariable('REDIRECT_URL');

  return {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId: userPoolWebClientId,
        loginWith: {
          oauth: {
            domain: `auth.${domain}.openhouse-group.com`,
            scopes: ['openid'],
            redirectSignIn: [redirectURL],
            redirectSignOut: [
              `https://${getEnvVariable('DOMAIN')}.openhouse-group.com/`,
            ],
            responseType: 'code',
          },
        },
      },
    },
  };
};

Amplify.configure(getCongnitoConfig());

const clearSetting = () => {
  store.dispatch(clearAccessToken());
  removeDailyStorage();
};

export const signOutProcess = async (callBack) => {
  // OH_KDSFA-2507 未ログイン時のgetCurrentUser()エラーを処理
  try {
    // OH_KDSFA-2507 ローカルストレージのログイン状態を確認
    await getCurrentUser();
    await signOut();
  } catch (e) {
    console.error(e);
  } finally {
    clearSetting();
    if (callBack) callBack();
  }
};

export const signInProcess = async (successCallBack, failureCallback) => {
  try {
    const res = await fetchAuthSession();
    const accessToken = res.tokens?.idToken?.toString();
    if (!accessToken) throw new Error('ID token is not available');
    store.dispatch(setAccessToken(accessToken));
    if (successCallBack) successCallBack(res);
  } catch (e) {
    console.error(e);
    await signOutProcess();
    if (failureCallback) failureCallback(e);
  }
};
